import React from 'react'
import { Link } from "react-router-dom";
function HeroSection() {
  return (
    <div>
      <section
        className="hero-section style-four"
        style={{ backgroundImage: "url('assets/img/bg-img/64.jpg')" }}
      >
        <div className="container">
          <div className="row g-4 g-lg-5 align-items-center justify-content-between">
            <div className="col-12 col-lg-6">
              {/* Hero Content */}
              <div className="hero-content mt-5">
                <div
                  className="text-white mb-2 h5 wow fadeInUp"
                  data-wow-delay="300ms"
                  data-wow-duration="1000ms"
                >
                  Empowering Justice
                </div>
                <h2
                  className="mb-4 wow fadeInUp text-white"
                  data-wow-duration="1000ms"
                  data-wow-delay="500ms"
                >
                  Trusted Legal Partner in Every Matter
                </h2>
                <p
                  className="text-white wow fadeInUp"
                  data-wow-duration="1000ms"
                  data-wow-delay="600ms"
                >
                  There are many variations of passages of Ipsum available, but
                  the majority suffered form randomised words injected.
                </p>
                <div className="d-flex flex-wrap align-items-center gap-4">
                  {/* Button */}
                  <Link
                    className="btn btn-primary wow fadeInUp"
                    to="/contactone"
                    data-wow-duration="1000ms"
                    data-wow-delay="700ms"
                  >
                    <span>
                      Get In Touch <i className="ti ti-arrow-up-right"></i>
                    </span>
                    <span>
                      Get In Touch <i className="ti ti-arrow-up-right"></i>
                    </span>
                  </Link>

                  {/* Play Video */}
                  <div
                    className="play-video-btn video-btn wow fadeInUp"
                    data-wow-duration="1000ms"
                    data-wow-delay="900ms"
                    data-video="https://youtu.be/4GUFkrHvZdE"
                  >
                    <div className="icon">
                      <i className="ti ti-player-play-filled"></i>
                    </div>
                    <span>Watch Video</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-lg-5">
              {/* Hero Thumbnail */}
              <div
                className="hero-thumbnail pe-0 wow fadeIn"
                data-wow-duration="1000ms"
                data-wow-delay="1100ms"
              >
                <img className="w-100" src="assets/img/bg-img/63.png" alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </section>
    </div>
  )
}

export default HeroSection
